"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const config_1 = __importDefault(require("../config"));
const query_string_1 = require("query-string");
class General {
    static async CheckStatus() {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/status`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async Ping(username, organization, has_unsynced_orders = 0, additional_data) {
        try {
            const options = {
                withCredentials: true
            };
            const params = {
                username,
                organization,
                has_unsynced_orders,
                data: additional_data
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/internal/ping?${(0, query_string_1.stringify)(params)}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetStagingListing() {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/internal/api/get-environments`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = General;
